import axios from 'axios';

let axiosInstance = axios.create({
	// baseURL: "http://api.tujjor.org/api/",
	baseURL: 'https://cdn.huquqiyportal.uz/api/',
	// baseURL: 'http://localhost:6600/api/',
});

axiosInstance.interceptors.request.use(
	(request) => {
		request.headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
		return request;
	},
	(error) => {
		return error;
	}
);

// export const API = "http://api.tujjor.org/api/";
export const API = 'https://cdn.huquqiyportal.uz/api/';

// export const APIFile = "http://api.tujjor.org/";
export const APIFile = 'https://cdn.huquqiyportal.uz';

export default axiosInstance;
